module.exports = __webpack_public_path__ + "img/duty.884673e9.svg";